import template from './mx-shell-unified-search.html';
import defaultBackgroundTemplate from './bg-svg.html';
import { EventCodes } from '../../../../App/model/event-codes';

export class MxShellUnifiedSearchComponentController {
	static $inject = ['$element', '$scope', '$timeout', 'mx.shell.SearchProviderService', 'mx.shell.EventService', 'mx.shell.HostUrlHelper', 'mx.shell.RoutingService'];

	constructor($element, $scope, $timeout, searchProviderService, eventService, hostUrlHelper, routingService) {
		Object.assign(this, { $element, $scope, $timeout, searchProviderService, eventService, hostUrlHelper, routingService });

		this.searchProviderService = searchProviderService;
		this.eventService = eventService;
		this.hostUrlHelper = hostUrlHelper;
		this.routingService = routingService;
		this.inputEl = $element.find('.mx-shell-unified-search--input-zone input');
		this.searchBtn = $element.find('.mx-shell-unified-search--search-btn');
		this.dropdownEl = $element.find('.mx-shell-unified-search--dropdown');
		this.cleanBtn = $element.find('.mx-shell-unified-search--icon-clear');
		this.inputArea = $element.find('.mx-shell-unified-search--input-container');

		this.defaultBackgroundTemplate = defaultBackgroundTemplate;
		this.searchContexts = [];
		this.selectedTags = [];

		this.isVisible = true;
	}

	$onInit() {
		const { $element, $scope, $timeout, eventService } = this;
		this.initSearchOptions();

		this.initFoldingEvents($element, $scope);

		eventService.subscribeTo(mx.shell.EventCodes.RouteActivated, () => $timeout(() => this.initSearchOptions()), $scope);
		eventService.subscribeTo(mx.shell.EventCodes.Search, (e, searchOptions) => this.initSearchOptions(searchOptions.keyword), $scope);
		eventService.subscribeTo(mx.shell.EventCodes.GlobalSearchConfigChanged, () => this.initSearchOptions(), $scope);

		eventService.subscribeTo(
			mx.shell.EventCodes.DisplayModeChanged,
			(event, newMode) => {
				this.isVisible = newMode === mx.shell.DisplayMode.Normal;
			},
			$scope
		);
	}

	$onChanges(changes) {
		if (changes.background) {
			this.backgroundImage = (changes.background.currentValue && this.hostUrlHelper.getFullImageUrl(changes.background.currentValue)) || '';
		}
	}

	async initSearchOptions(keyword) {
		const { searchProviderService } = this;
		const globalSearchParameters = await searchProviderService.getCurrentGlobalSearchParameters();
		this.searchContexts = globalSearchParameters.contexts.slice();
		this.selectedTags = this.searchContexts.filter((tag) => tag.selected);
		this.searchText = keyword || globalSearchParameters.keyword;
		this.showContextWhenNotFocused = globalSearchParameters.isGlobal;
	}

	initFoldingEvents($element, $scope) {
		document.addEventListener(
			'mousedown',
			(event) => {
				if (this.focused && event.target !== this.searchBtn[0] && $(event.target).closest(this.inputArea).length === 0) {
					$scope.$applyAsync(() => {
						this.inputEl.blur();
						this.focused = false;
					});
				}
			},
			true
		);

		this.inputArea.click((event) => {
			if (![this.cleanBtn[0], this.searchBtn[0]].includes(event.target)) {
				this.inputEl.focus();
			}
		});
	}

	performSearch() {
		const selectedContexts = this.searchContexts.filter((context) => context.selected);
		if (this.searchText.length >= 3) {
			this.eventService.dispatchEvent(EventCodes.TrackTelemetry, {
				eventName: 'Global search executed',
				senderTitle: 'Unified search panel',
				contextTypeId: selectedContexts.map((context) => context.navigationItem?.id),
				contextTypeTitle: selectedContexts.map((context) => context.navigationItem?.technicalName),
			});

			this.searchProviderService.performSearch(this.searchText, selectedContexts);
			this.focused = false;
		} else {
			this.inputEl.focus();
		}
	}
	cleanSearch() {
		this.selectedTags = [];
		this.searchContexts.forEach((context) => (context.selected = false));
		this.searchText = '';
		this.inputEl.focus();
	}

	selectTag(tag) {
		tag.selected = true;
		this.selectedTags.push(tag);
	}

	unselectTag(tag) {
		tag.selected = false;
		this.selectedTags.splice(this.selectedTags.indexOf(tag), 1);
	}
}

angular.module('mx.shell').component('mxShellUnifiedSearch', {
	controller: MxShellUnifiedSearchComponentController,
	controllerAs: 'vm',
	template: template,
	bindings: {
		title: '@',
		subTitle: '@',
		transparent: '<',
		background: '<',
		expandedMode: '<',
		titleColor: '<',
	},
});
